import { ContributionTypeEnum } from '../../api/users/interfaces/ContributionData';
import { UserEppConfigForModeDataI } from '../../api/users/interfaces/UserEppConfigForMode';
import { TipoPlanResumen } from './planes';

export interface AportacionMensual {
	tu: number;
	empresa: number;
}

export interface EntradaAportacion {
	tipo: TipoPlanResumen;
	/** `data` de `GET /users/epp-config` de ESTE plan; `null` si no llegó. */
	config: UserEppConfigForModeDataI | null;
	/** Salario bruto anual, para las aportaciones de empleo en porcentaje. */
	salario: number | null | undefined;
	/**
	 * €/mes de la empresa (`calculatedEmployerContribution`). Solo cuenta en el plan de empleo
	 * VIGENTE; para el resto, quien llama pasa 0. `null` = no se sabe.
	 */
	empresa: number | null | undefined;
}

/**
 * La aportación mensual de un plan, como la enseñan Inicio y Tu beneficio: lo configurado se lee
 * como €/mes (Inicio no lo divide por la periodicidad), y en empleo en porcentaje se pasa a euros
 * con el salario (`MiBeneficioV2`).
 *
 * `null` = no se sabe, y entonces la card no afirma nada: ni un porcentaje leído como euros, ni
 * un total de empleo sin la parte de la empresa.
 */
export function aportacionMensual({
	tipo,
	config,
	salario,
	empresa
}: EntradaAportacion): AportacionMensual | null {
	if (!config) return null;
	const configurada = Number(config.pensionContribution ?? 0);
	const enPorcentaje = config.employeeContributionType === ContributionTypeEnum.PERCENTAGE;
	if (enPorcentaje && !salario) return null;
	const tu = enPorcentaje ? ((configurada / 100) * (salario as number)) / 12 : configurada;
	if (tipo !== 'EMPLEO') return { tu, empresa: 0 };
	if (empresa === null || empresa === undefined) return null;
	return { tu, empresa };
}
